import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { UpdateDraftAppointmentDescriptionDocument } from '~/graphql/generated/graphql';

export const useUpdateMemo = (draftAppointmentId: string) => {
  const [updateMemo, { loading }] = useMutation(UpdateDraftAppointmentDescriptionDocument);

  const handleChangeMemo = useCallback(
    async (memo: string) => {
      try {
        await updateMemo({ variables: { input: { draftAppointmentId, description: memo } } });
      } catch {
        // 何もしない
      }
    },
    [draftAppointmentId, updateMemo],
  );

  return {
    handleChangeMemo,
    updating: loading,
  };
};
